import { render, staticRenderFns } from "./ShareDrawer.vue?vue&type=template&id=5357fdf2&scoped=true&"
import script from "./ShareDrawer.vue?vue&type=script&lang=js&"
export * from "./ShareDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5357fdf2",
  null
  
)

export default component.exports